import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-button-cell-renderer',
  
  template: '<button type="button" class="btn btn-primary btn-sm mt-1" (click)="btnClickedHandler($event)">{{value}}</button>'
  
})
export class ButtonCellRendererComponent  implements ICellRendererAngularComp, OnDestroy {
  
  value;
  refresh(params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }
   params: any;
 
  agInit(params: any): void {
          this.params = params;
         if(params.colDef.field=="ACTION")
       {  
        this.value="EDIT";
        }
       else if(params.colDef.field=="VIEW")
       {
        this.value="VIEW"; 
        }
        else if(params.colDef.field=="ASSIGN")
       {
        this.value="ASSIGN"; 
        }
    }

  btnClickedHandler(event) {
    this.params.clicked(this.params.data);
  }

  ngOnDestroy() { 
     // no need to remove the button click handler 
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
